import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { isReadOnly } from '../utils/readOnly';

const styles = theme => ({
  button: {
    margin: theme.spacing(1)
  },
  left: {
    marginRight: theme.spacing(1)
  },
  user: {
    color: theme.palette.common.white
  },
  pic: {
    margin: theme.spacing(1)
  }
});

class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null
    };
  }

  openMenu = evt => {
    this.setState({ anchorEl: evt.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleShowPreferences = () => {
    this.setState({ anchorEl: null });
    this.props.onShowPreferences();
  };

  signOut = () => {
    window.location = `${window.runConfig.REACT_APP_API_URL}/auth/signout`;
  };
  
  // <img className={classes.pic} src={userInfo.picture} alt="" height="48" width="48" />

  render() {
    const { anchorEl } = this.state;
    const { classes, userInfo } = this.props;

    return (
      <div className={classes.user}>
        <Button
          color="inherit"
          className={classes.button}
          onClick={this.openMenu}
          aria-haspopup="true"
          aria-owns={anchorEl ? 'user-menu' : null}
        > {userInfo.name}
        </Button>
        {isReadOnly(userInfo) && (
          <Button
            className={classes.button}
            onClick={() => {alert(`You are logged in with READONLY role ${userInfo.role}. Most buttons are disabled.`)}}
            color="secondary"
          >READONLY</Button>
        )}
        <Menu
          id="user-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <MenuItem onClick={this.handleShowPreferences}>Preferences</MenuItem>
          <MenuItem onClick={this.signOut}>Sign Out</MenuItem>
        </Menu>
      </div>
    )
  }
}

User.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(User);
